import { Component} from '@angular/core';
import { NavController,AlertController, Navbar,App, ToastController } from 'ionic-angular';
import { HttpService } from '../../../providers/service/httpservice';
import { AppState } from '../../../app/app.global';
import { TabsPage } from '../../tabs/tabs/tabs';
import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';

@Component({
  selector: 'gesture-loginpage',
  templateUrl: 'gesturelogin.html'
})

export class GestureLoginPage {
  constructor(public navCtrl: NavController,public appCtrl: App,public global: AppState,
		private httpService:HttpService,private alertCtrl: AlertController,public toastCtrl: ToastController) {
	}

	//初始化
	ngOnInit(): void {}

	getPwdResult(event: any) {
		let inputgesture = `${event}`;
		let pwdgesture = StorageService.getObj("gesture");
		if(pwdgesture == null || inputgesture == pwdgesture){
			StorageService.setObj("gesturepassed",true);
			this.navCtrl.setRoot(TabsPage);
		}else{
			this.presentToast("手势不正确");
		}
	}
	presentToast(message) {
		const toast = this.toastCtrl.create({
			message: message,
			duration: 1000
		});
		toast.present();
	}
	toPwdlogin(){
		StorageService.remove('currentUser');
		this.appCtrl.getRootNav().push(LoginPage);
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/gesturelogin/gesturelogin.ts